import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '@workflow/ecp-shared/model/app.config.model';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private env: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private configData: any; // Temp setting to any instead of AppConfig;

  constructor(private readonly http: HttpClient) {}

  /**
   * Observable way to get application configs from parent application by .json asset
   * @returns json configuration file as observable
   */
  public get(): Observable<AppConfig> {
    if (this.configData) return of(this.configData);

    // Create time stamp to avoid caching
    const datetime = new Date().getTime();

    return this.http.get('./assets/data/config.json?cb=' + datetime).pipe(
      map((res) => {
        // TODO 208381: Let's look at how we're initializing configs. See 208381.
        this.configData = res;
        return this.configData;
      })
    );
  }
}
